import { useEffect, useRef } from "react";
import { useRouterState } from "@tanstack/react-router";
import { trackPageView } from "@/utils/analytics";

export function GTMPageTracker() {
  const { location } = useRouterState();
  const isFirstPageView = useRef(true);

  useEffect(() => {
    trackPageView();

    if (isFirstPageView.current) {
      isFirstPageView.current = false;
      return;
    }

    window.ttq?.page();
  }, [location.href]);

  return null;
}
